import { render, staticRenderFns } from "./detailSubscriptionOffers.vue?vue&type=template&id=4f766085&"
import script from "./detailSubscriptionOffers.vue?vue&type=script&lang=js&"
export * from "./detailSubscriptionOffers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports